import {
  GetWorkSpacesDocument,
  GetWorkSpacesQueryVariables,
  WorkSpaceFragment,
} from 'generated/resources/graphql'

import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'

import { DEFAULT_PAGINATED_CONNECTION } from 'modules/space_control/hooks/utils'

export type WorkSpaceNode = WorkSpaceFragment

export const useWorkSpaces = (variables: GetWorkSpacesQueryVariables) => {
  const { loading, nodes, controls } = usePaginatedQuery(GetWorkSpacesDocument, {
    variables,
    extractConnection: (data) =>
      data.spaceControl.workSpacesConnection ?? DEFAULT_PAGINATED_CONNECTION,
  })

  return {
    loading,
    workSpaces: nodes,
    controls,
    query: {
      query: GetWorkSpacesDocument,
      variables,
    },
  }
}
